import React, {useState, useEffect, useRef} from 'react';
import ReactDOM from 'react-dom';
import block from 'bem-cn-lite';

import './Sidebar.scss';
import {CSSTransition} from 'react-transition-group';
import OutsideClick from 'components/OutsideClick/OutsideClick';

const b = block('sidebar');
const TRANSITION_TIME = 400;

export interface SidebarProps {
    isOpened: boolean;
    onClose: () => void;
    className?: string;
}
const Sidebar: React.FunctionComponent<SidebarProps> = ({
    isOpened,
    children,
    onClose,
    className,
}) => {
    const [body, setBody] = useState<HTMLElement>();
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => setBody(document.body), []);

    useEffect(() => {
        document.body.classList.toggle(b('no-scroll'), isOpened);

        return () => {
            document.body.classList.remove(b('no-scroll'));
        };
    }, [isOpened]);

    if (!body) {
        return null;
    }

    return ReactDOM.createPortal(
        <CSSTransition
            in={isOpened}
            classNames={b('transition')}
            unmountOnExit
            timeout={TRANSITION_TIME}
        >
            <OutsideClick className={b(null, className)} onOutsideClick={onClose}>
                <div ref={ref} className={b('bar')}>
                    {children}
                </div>
            </OutsideClick>
        </CSSTransition>,
        body,
    );
};

export default Sidebar;
